export default () => {
    $('.desktop.id--9 .cart-summary').appendTo('.sidebar-in-cart')
};